import { useEffect } from "react"
import { getCalApi } from "@calcom/embed-react"
import { CALENDARIZE_EMBED_JS_URL } from "@/utils/calendarize"

export function useCalendarizeUi(onSuccess?: () => void) {
  useEffect(() => {
    ;(async function () {
      //@ts-expect-error cal.com type issue
      const cal = await getCalApi({ embedLibUrl: CALENDARIZE_EMBED_JS_URL })
      cal("ui", {
        styles: { branding: { brandColor: "#000000" } },
        hideEventTypeDetails: false,
        layout: "month_view",
      })

      if (onSuccess) {
        cal("on", {
          action: "bookingSuccessful",
          callback: onSuccess,
        })
      }
    })()
  }, [onSuccess])
}
